export default {
      id: "ic_live_stream-usage",
      viewBox: "0 0 48 45",
      url: "/" + "images/icons.3.109.2.svg#ic_live_stream-usage",
      toString: function () {
        return this.url;
      }
    }